import React from 'react';
import { Button, Card, Col, FormControl, Row } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';

import { ButtonSplitGroup } from '@components/Buttons';
import { DefaultSpinnerCenter } from '@components/Loader/Loader';
import { Page500 } from '@containers/ErrorPages';
import { authApi } from '@reducers/auth';

export const ApiPage = () => {
  const { login } = useSelector((state) => state.auth.user) || '';
  const apiToken = authApi.useGetApiTokenQuery();
  const [regenerateApiToken, regenerateApiTokenResult] =
    authApi.useRegenerateApiTokenMutation();

  if (apiToken.isLoading || apiToken.isFetching) {
    return <DefaultSpinnerCenter />;
  }

  if (apiToken.isError && apiToken.error.status === 500) {
    return <Page500 />;
  }
  if (apiToken.isError && apiToken.error.status === 400) {
    return (
      <Row>
        <Col>
          <Card>
            <Card.Header className="bg-didxl text-white text-center">
              API Key
            </Card.Header>
            <Card.Body>{apiToken.error.data?.detail}</Card.Body>
          </Card>
        </Col>
      </Row>
    );
  }
  let token;
  let location;
  if (!apiToken.data) {
    token = 'Generate token';
    location = null;
  } else {
    token = apiToken.data.token;
    location = apiToken.data.docs_location;
  }
  return (
    <Row>
      <Col>
        <Card>
          <Card.Header className="bg-didxl text-white text-center">
            API Key
          </Card.Header>
          <Card.Body>
            <Row>
              <Col>
                <FormControl
                  className="text-center"
                  type="input"
                  disabled
                  value={token}
                />
              </Col>
            </Row>
            <Row className="mt-2">
              <Col className="text-center">
                <ButtonSplitGroup>
                  <Button
                    variant="didxl"
                    onClick={() =>
                      regenerateApiToken({ login })
                        .unwrap()
                        .then(() => {
                          apiToken.refetch();
                        })
                    }
                    disabled={regenerateApiTokenResult.isLoading}
                  >
                    Generate new key
                  </Button>
                  {location ? (
                    <Button variant="didxl" as={Link} to={location}>
                      Docs
                    </Button>
                  ) : (
                    <Button variant="didxl" disabled>
                      Docs
                    </Button>
                  )}
                </ButtonSplitGroup>
              </Col>
            </Row>
          </Card.Body>
        </Card>
      </Col>
    </Row>
  );
};
